<template>
    <div class="spread-comp">
        <div  id="spread__Content"  class="spread_content" @focus="selectFocus(item)" >
            <el-popover ref="pop_fujian"
                        placement="bottom-end"
                        popper-class="set_pop_content"

                        trigger="click">
                <fujian ref="fujian"  :fj="fjFile"  style="height:100%;width:100%;" ></fujian>
            </el-popover>

        </div>
        <mydialog  ref="mydialog"   ></mydialog>


    </div>
</template>
<script>
    import mydialog from "@/components/dialog"; // dialog
    import fujian from "./fujian";
    import * as jUtil from '@/utils/gcExcelJs.js';
    import menu from '@/views/report/res/menu.js';
    export default {
        name: "spread_base",

        components: {
            mydialog,
            fujian
        },

        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },

        },

        data() {
            return {
                spread_ContentId:'spread__Content',
                spread:{},
                excelIo:{},
                spreadNS : GC.Spread.Sheets,
                fjFile:{},
                spreadData:{},
                spreadStyle:{},
                editState:false,
                importType:false,


                activeSheet:{},

                editIds:{},
                sets:{},
            }
        },


        mounted() {

            const div=document.getElementById("spread__Content");
            if(div) {
                this.spread_ContentId = "sp_comp_"+new Date().getTime();
                div.id= this.spread_ContentId;
            }


            this.initSpread();
            this.$emit("load");
            window.addEventListener("drag-resize",this.onResize);
            this.onResize();

        },
        beforeDestroy(){
        },
        methods: {
            initSpread() {
                let _this = this;
                this.sets = {};
                this.spreadData.template = {};
                this.spreadData.set = {};
                this.spread=new this.spreadNS.Workbook($('#'+ this.spread_ContentId)[0]);
                this.excelIo =new GC.Spread.Excel.IO();
                this.spread.bind(GC.Spread.Sheets.Events.ValueChanged, this.editChanged);
                this.spread.bind(GC.Spread.Sheets.Events.ClipboardPasting, this.editChanged);
                this.spread.bind(GC.Spread.Sheets.Events.SelectionChanged, this.rangeChanged);
                this.spread.bind(GC.Spread.Sheets.Events.ButtonClicked,  this.actButton);
                // this.spread.getHost().addEventListener('click', function(e) {
                // });
                        this.spread.options.tabEditable = false;


            },
            onResize() {
              //  $('.spread-comp').height($(".spread-comp").parent().height()  );
              //  $('.spread-comp').width($(".spread-comp").parent().width()*1 -1 );
                $('#'+this.spread_ContentId).height($('#'+this.spread_ContentId).parent().parent().height()  -4);
                $('#'+this.spread_ContentId).width($('#'+this.spread_ContentId).parent().parent().width()*1 );
                this.spread.refresh();

            },

            onOpen(callback){
                callback(true);
            },
            btn(id) {
                let sheet = this.spread.getActiveSheet();
                if (id == undefined) return;
                let id_family = id.split("-");
                let sid = id_family[1];
                switch (id_family[0]) {
                    case 'file':
                        this.setFile(sid);
                        break;
                    case 'page':
                        this.setPage(sid);
                        break;
                    case 'freeze':

                        sheet.options.frozenlineColor ="green";
                        sheet.frozenRowCount(sheet.getActiveRowIndex());
                        sheet.frozenColumnCount(sheet.getActiveColumnIndex());
                        break;


                    default:
                        break;
                }
            },

            viewSpread(a,n) {
                let _this=this;
                this.spread.fromJSON(a.gcExcel);
                this.rptParm=a.rpt;
                this.importType=n.importType;
                this.editIds={};
                this.spreadStyle=a.set.hasOwnProperty("style")?a.set.style:{};
                let option = {
                    allowSelectLockedCells: true,
                    allowSelectUnlockedCells: true,
                    allowFilter: true,
                    allowSort: true,
                    allowResizeRows: true,
                    allowResizeColumns: true,
                    allowEditObjects: true,
                    allowDragInsertRows: false,
                    allowDragInsertColumns: false,
                    allowInsertRows: true,
                    allowInsertColumns: false,
                    allowDeleteRows: true,
                    allowDeleteColumns: false,
                    allowOutlineColumns: false,
                    allowOutlineRows: true
                };
                let sheet = this.spread.getActiveSheet();

                sheet.options.protectionOptions = option;
                sheet.options.isProtected = true;
                this.spread.contextMenu.menuData=[];//.splice(0, 48);
                this.createContextFilterMenu(this.spread.contextMenu.menuData);
                if(n.editState==0) this.createContextUpdateMenu(this.spread.contextMenu.menuData);
                if (this.spreadStyle.hasOwnProperty("link"))this.createContextReportMenu(this.spread.contextMenu.menuData,this.spreadStyle.link);
                this.spread.contextMenu.onOpenMenu = function(menuData, itemsDataForShown, hitTest, spread){
                    _this.setContextMenu(menuData, itemsDataForShown, hitTest, spread);
                };
                if (n.editState==0) this.initEdit();


            },
            setButtonState(type) {
                if (type)
                    $(".editbutton").removeClass("font-disable");
                else
                    $(".editbutton").addClass("font-disable");
            },
            actButton(e,args)
            {
                let tag=args.sheet.getTag(args.row , args.col);
                if (tag) {
                    this.fjFile=tag;
                    this.$refs.pop_fujian.showPopper =true;
                }
            },

            initEdit(){
                let _this=this;
                let oldsheet = this.spread.getActiveSheet();
                this.spread.sheets.forEach((item) => {
                    let sheet=item;
                    _this.spread.setActiveSheet(item.name);
                    sheet.tables.all().forEach((table) => {
                        let range=table.dataRange();
                        sheet.setActiveCell(range.row,range.col);
                        if (range.rowCount==1)
                        {
                            let id = sheet.getValue(range.row, range.col + table.getColumnIndexInTable("id"));
                            if (id==null && this.spreadStyle.hasOwnProperty(table.name()))
                            {
                                this.cusUpdate("Insert");
                                sheet.setActiveCell(range.row,range.col);
                                sheet.deleteRows(range.row , 1);
                            }
                        }
                    });
                });
                this.spread.setActiveSheet(oldsheet.name);
            },

            rangeChanged(e,args){
                this.$emit('cellClick');
                this.$refs.pop_fujian.showPopper =false;
                let sheet =this.spread.getActiveSheet();
                sheet.suspendPaint();
                if (args.oldSelections) {
                    for (let j = 0; j < args.oldSelections.length; j++) {
                        let row = args.oldSelections[j].row;
                        let col = args.oldSelections[j].col;
                        let rowCount = args.oldSelections[j].rowCount;
                        let colCount = args.oldSelections[j].colCount;
                        let t = 0;
                        let table = sheet.tables.find(row, col);// 获取table
                        if (table && this.spreadStyle.hasOwnProperty(table.name())) {
                            let ts = this.spreadStyle[table.name()];
                            if (ts.hasOwnProperty('selectid')) {
                                let slist = ts['selectid'].split(',');
                                for (let k = 0; k < slist.length; k++) {
                                    ts['ids_' + slist[k]] = [];
                                }
                                let range = table.dataRange();
                                t++;
                                for (let i = 0; i < rowCount; i++) {
                                    let r = i + row;
                                    if (r >= range.row && r < range.row + range.rowCount && sheet.getRowVisible(r)) sheet.getRange(r, range.col, 1, range.colCount).backColor(undefined);
                                }
                            }
                        }
                    }
                }
                for (let j=0;j<args.newSelections.length;j++) {
                    let row = args.newSelections[j].row;
                    let col = args.newSelections[j].col;
                    let rowCount = args.newSelections[j].rowCount;
                    let colCount = args.newSelections[j].colCount;
                    let t=0;
                    let table = sheet.tables.find(row, col);// 获取table
                    if (table && this.spreadStyle.hasOwnProperty(table.name())) {
                        let ts=this.spreadStyle[table.name()];
                        if (ts.hasOwnProperty('selectid')) {

                            let slist=ts['selectid'].split(',');

                            for (let k=0;k<slist.length;k++) {
                                ts['ids_'+ slist[k]]=[];
                            }
                            let range = table.dataRange();


                            t++;
                            for (let i = 0; i < rowCount; i++) {
                                let r = i + row;
                                if (r >= range.row && r < range.row + range.rowCount && sheet.getRowVisible(r)) {
                                    sheet.getRange(r, range.col, 1, range.colCount).backColor("#b7d0b2");
                                    for (let k=0;k<slist.length;k++) {
                                        let id = sheet.getValue(r, range.col + table.getColumnIndexInTable(slist[k]));
                                        ts['ids_' + slist[k]].push( id);
                                    }
                                }
                            }
                        }
                    }
                }
                    sheet.resumePaint();
                    sheet.repaint();
            },
            editChanged(e, args) {
                let sheet =this.spread.getActiveSheet();
                let table = sheet.tables.find(args.row, args.col);// 获取table
                if (table) {
                    let tableName = table.name();
                    let range = table.dataRange();
                    let col = table.getColumnIndexInTable('id');
                    let id = sheet.getValue(args.row, range.col + col);
                    if (id==null ) {id=0;sheet.setValue(args.row, range.col + col,0)};
                    if (id==0) return;
                    if (this.editIds.hasOwnProperty(tableName)) {
                        if (!this.editIds[tableName].includes(id)) {
                            this.editIds[tableName].push(id);
                        }
                    }
                    else
                        this.editIds[tableName]=[id];
                }
            },




            setPage(op) {
                let sheet = this.spread.getActiveSheet();
                switch (op) {
                    case 'print':
                        let printInfo = sheet.printInfo();

                        printInfo.paperSize(new GC.Spread.Sheets.Print.PaperSize(GC.Spread.Sheets.Print.PaperKind.a4));
                        printInfo.orientation(GC.Spread.Sheets.Print.PrintPageOrientation.landscape);//打印的页面方向。portrait纵 landscape
                        printInfo.margin({ top: 10, bottom: 0, left: 10, right: 0, header: 0, footer: 0 });
                        printInfo.showBorder(false);
                        printInfo.showGridLine(false);
                        sheet.printInfo(printInfo);
                        this.spread.print(0);
                        break;
                    case 'zoom_in':
                        var zoom = this.spread.getActiveSheet().zoom();
                        this.spread.getActiveSheet().zoom(zoom - 0.1);
                        break;
                    case 'zoom_out':
                        var zoom = this.spread.getActiveSheet().zoom();
                        this.spread.getActiveSheet().zoom(zoom + 0.1);
                        break;
                    case 'saveas':
                        this.saveTemplateToExcel();
                        break;
                    case 'freeze':

                        sheet.options.frozenlineColor ="#A0D0B3";
                        sheet.frozenRowCount(sheet.getActiveRowIndex());
                        sheet.frozenColumnCount(sheet.getActiveColumnIndex());
                        break;

                    default:
                        break;
                }
            },
            //保存EXCEL
            saveTemplateToExcel() {
                //生成时间戳

                // let sjson =this.spread.toJSON();
                // let sheet = this.spread.getActiveSheet();
                // sheet.tables.all().forEach(function(table){
                //     sheet.tables.remove(table, GC.Spread.Sheets.Tables.TableRemoveOptions.keepData | GC.Spread.Sheets.Tables.TableRemoveOptions.keepStyle) ;
                //
                // });
                let fileName = new Date().getTime() + '.xlsx';
                let json = this.spread.toJSON();
                // this.spread.fromJSON(sjson);
                this.excelIo.save(json, (blob) => {
                    saveAs(blob, fileName);
                }, function (e) {
                    console.log(e);
                });

            },




            newUuid() {
                let guid = "";
                for (let i = 1; i <= 24; i++) {
                    let g = Math.floor(Math.random() * 16.0).toString(16);
                    guid += g;
                }
                return guid.toUpperCase();
            },
            /*
                  *  通过继承ContextMenu的方式自定义右键菜单逻辑
                  * */
            createContextFilterMenu(menuData) {
                let _this = this;

                let filterList = ['Asc','Desc','separator','Data','Custom', 'Back','Clear'];
                for (let i = 0; i < filterList.length; i++) {
                    let command = {
                        canUndo: true,
                        execute: function (context, options, isUndo) {
                            let Commands = GC.Spread.Sheets.Commands;
                            options.cmd = _this.cusFilter(filterList[i]);
                            if (isUndo) {
                                Commands.undoTransaction(context, options);
                                return true;
                            } else {
                                Commands.startTransaction(context, options);
                            }
                        }

                    };
                    if (filterList[i]==='separator')
                    {menuData.push({type: "separator"});}
                    else {
                        menuData.push(menu["filter" + filterList[i]]);
                        this.spread.commandManager().register("filter" + filterList[i], command);
                    }
                }
                return menuData;
            },


            /*
        *  通过继承ContextMenu的方式自定义右键菜单逻辑
        * */
            createContextUpdateMenu(menuData) {
                let _this = this;

                let filterList = ['separator','Insert','Delete'];
                for (let i = 0; i < filterList.length; i++) {

                    let command = {
                        execute: function (context, options, isUndo) {
                            let Commands = GC.Spread.Sheets.Commands;
                            options.cmd = _this.cusUpdate(filterList[i]);
                        }

                    };

                    if (filterList[i]==='separator')
                    {menuData.push({type: "separator"});}
                    else {
                        menuData.push(menu["table" + filterList[i]]);
                        this.spread.commandManager().register("table" + filterList[i], command);
                    }
                }
            },
            /*
                *  通过继承ContextMenu的方式自定义右键菜单逻辑
                * */
            createContextReportMenu(menuData,link) {
                let _this = this;
                menuData.push({type: "separator"});
                for (let i = 0; i < link.length; i++) {
                     let command = {
                        execute: function (context, options, isUndo) {
                            let Commands = GC.Spread.Sheets.Commands;
                            options.cmd = _this.cusReport(link[i]);
                        }

                    };

                    let obj ={
                        command:'link_'+link[i].name,
                        text:'联查->'+link[i].title,
                        name:link[i].name,
                        iconClass:"gc-spread-custom-icon",
                        workArea: link[i].table?link[i].table:"Table1"
                    };
                    menuData.push(obj);
                    this.spread.commandManager().register(obj.command, command);
                }
                return menuData;
            },
            /*
                         *  通过继承ContextMenu的方式自定义右键菜单逻辑
                         * */
            setContextMenu(menuData, itemsDataForShown, hitTest, spread) {
                let _this = this;
                let sheet =spread.getActiveSheet();
                let sels = sheet.getSelections()[0];
                let table = sheet.tables.find(sels.row, sels.col);// 获取table
                if (table) {
                    let tableName = table.name();
                    let tableObj=_this.spreadStyle.hasOwnProperty(tableName)?_this.spreadStyle[tableName]:null;
                    let range=table.range();

                    for (let i = 0; i < itemsDataForShown.length; i++) {
                        let item = itemsDataForShown[i];
                        if (item.workArea != tableName && item.workArea != 'table') {
                            item.disable = true;
                        }
                        if (item.name==='filterData' && sels.row==range.row)
                        {
                            item.disable = true;
                        }
                        if (item.name==='tableInsert' &&( tableObj==null || !tableObj.hasOwnProperty("insert")))
                        {

                            item.disable = true;
                        }
                        if (item.name==='tableDelete' && ( tableObj==null || !tableObj.hasOwnProperty("delete")))
                        {

                            item.disable = true;

                        }
                    }
                }

                return true;
            },


            cusFilter(type) {
                let filterDialogDom = $('[id^=gc-dialog].gc-filter-dialog-style');
                filterDialogDom.remove();
                //
                let sheet =this.spread.getActiveSheet();
                let sels = sheet.getSelections()[0];
                let table = sheet.tables.find(sels.row, sels.col);// 获取table
                if (table) {
                    sheet.suspendPaint();
                    let range=table.range();
                    switch (type) {
                        case 'Data': {
                            const compareType = GC.Spread.Sheets.ConditionalFormatting.TextCompareType.equalsTo;
                            const condition = new GC.Spread.Sheets.ConditionalFormatting.Condition(
                                GC.Spread.Sheets.ConditionalFormatting.ConditionType.textCondition,
                                {compareType, expected: sheet.getText(sels.row, sels.col).trim()}
                            );
                            if (sheet.rowFilter() == null) sheet.rowFilter(new GC.Spread.Sheets.Filter.HideRowFilter(table.dataRange()));
                            sheet.rowFilter().filterButtonVisible(false);
                            const filter = sheet.rowFilter();
                            filter.addFilterItem(sels.col, condition);
                            filter.filter();
                        }
                            break;

                        case 'Back': {
                            const filter = sheet.rowFilter();
                            if (filter==null) return;
                            let fc=filter.Je;
                            filter.removeFilterItems(fc[fc.length -1]);
                            filter.filter();
                        }
                            break;
                        case 'Clear': {
                            //sheet.rowFilter(new GC.Spread.Sheets.Filter.HideRowFilter(table.range()));
                            sheet.rowFilter(null);
                        }
                            break;
                        case 'Custom': {
                            if (sheet.rowFilter() == null) sheet.rowFilter(new GC.Spread.Sheets.Filter.HideRowFilter(table.dataRange()));
                            let rowFilter = sheet.rowFilter();
                            sheet.rowFilter().filterButtonVisible(false);
                            sheet.getCellRect(sels.row, sels.col);
                            let celRect = sheet.getCellRect(sels.row, sels.col);
                            let filterInfo = {
                                "rowFilter": rowFilter,
                                "row": range.row,
                                "col": sels.col,
                                "sheetArea": 3,
                                "x": celRect.x + celRect.width - 20,
                                "y": celRect.y,
                                "width": 20,
                                "height": 20
                            };
                            rowFilter.openFilterDialog(filterInfo);
                        }
                            break;
                        case 'Asc': {
                            //sheet.rowFilter(new GC.Spread.Sheets.Filter.HideRowFilter(table.range()));
                            if (sheet.rowFilter() == null) sheet.rowFilter(new GC.Spread.Sheets.Filter.HideRowFilter(table.dataRange()));
                            sheet.rowFilter().filterButtonVisible(false);
                            let rowFilter = sheet.rowFilter();
                            rowFilter.sortColumn(sels.col -range.col , true);

                        }
                            break;
                        case 'Desc': {
                            if (sheet.rowFilter() == null) sheet.rowFilter(new GC.Spread.Sheets.Filter.HideRowFilter(table.dataRange()));
                            sheet.rowFilter().filterButtonVisible(false);
                            let rowFilter = sheet.rowFilter();

                            rowFilter.sortColumn(sels.col -range.col , false);


                        }
                            break;
                        default:
                            break;
                    }
                    sheet.resumePaint();
                }
            },
            cusUpdate(type) {
                let _this=this;
                let filterDialogDom = $('[id^=gc-dialog].gc-filter-dialog-style');
                filterDialogDom.remove();
                //let title = obj.title;
                let sheet =this.spread.getActiveSheet();
                let sels = sheet.getSelections()[0];
                let table = sheet.tables.find(sels.row, sels.col);// 获取table
                if (table) {
                    sheet.suspendPaint();
                    let range=table.dataRange();
                    let tableName = table.name();
                    let tableObj=_this.spreadStyle[tableName];
                    let upObj=tableObj[type.toLowerCase()];
                    switch (type) {
                        case 'Insert': {
                            sheet.options.isProtected = false;
                            sheet.addRows(range.rowCount + range.row ,1,true);
                            sheet.copyTo(range.row ,range.col,range.row+range.rowCount,range.col,1,range.colCount,GC.Spread.Sheets.CopyToOptions.style);
                            sheet.setRowHeight(range.rowCount + range.row , sheet.getRowHeight( range.row ));
                            sheet.setActiveCell(range.rowCount + range.row,sels.col);
                            sheet.options.isProtected = true;
                            let cols=upObj.allowedit.split(",");
                            for (let i = 0; i < cols.length; i++) {
                                let col = table.getColumnIndexInTable(cols[i]);
                                sheet.getRange(range.rowCount + range.row ,col).locked(false);
                            }
                            this.$emit('getargData',(res)=> {
                                let a = res;
                                $.each(upObj.def, function (key, item) {
                                    let col = table.getColumnIndexInTable(key);
                                    let v = item;
                                    if (a.hasOwnProperty(item)) v = a[item];
                                    if (item == 'uuid') v = _this.newUuid();
                                    sheet.setValue(range.rowCount + range.row, col, v);
                                });
                            });


                        }
                            break;
                        case 'Delete': {
                            let valid = upObj.valid;
                            let reg = /\{(.+?)\}/g;
                            let result;
                            while (result = reg.exec(valid)) {
                                let colName = result[0].replace('{', '').replace('}', '');
                                let col = table.getColumnIndexInTable(colName);
                                let v = sheet.getValue(sels.row, range.col + col);
                                valid = valid.replaceAll(result[0], v);
                            }
                            let ret = eval(valid);
                            if (ret) {
                                let id = sheet.getValue(sels.row, range.col + table.getColumnIndexInTable("id"));
                                if (id == 0) {
                                    sheet.options.isProtected = false;
                                    sheet.deleteRows(sels.row , 1);
                                    //table.deleteRows(sels.row - range.row, 1);
                                    sheet.options.isProtected = true;

                                }
                                else {
                                    sheet.getRange(sels.row, range.col, 1, range.colCount).backColor("red");
                                    this.$confirm(this.$t('report_do_you_want_to_delete_this_row_of_data'), this.$t('tips_prompt'), {
                                        confirmButtonText: this.$t('button_sure'), cancelButtonText: this.$t('button_cancel'), type: 'warning'
                                    }).then( () => {
                                        this.$emit("deldetail",id,(res)=> {
                                            if (res.code == 1) {
                                                sheet.options.isProtected = false;
                                                sheet.deleteRows(sels.row , 1);
                                                sheet.options.isProtected = true;
                                                sheet.setActiveCell(sels.row, sels.col);
                                            }
                                        });

                                    }).catch(() => {
                                        sheet.getRange(sels.row, range.col, 1, range.colCount).backColor(null);
                                        return false;
                                    });
                                }
                            }else
                            {
                                _this.$message.error(upObj.err);
                            }

                        }
                            break;
                        default:
                            break;
                    }
                    sheet.resumePaint();

                }

            } ,//end
            cusReport(obj) {
                let _this=this;
                let filterDialogDom = $('[id^=gc-dialog].gc-filter-dialog-style');
                filterDialogDom.remove();

                let title = obj.title;
                let sheet =this.spread.getActiveSheet();
                let sels = sheet.getSelections()[0];
                let table = sheet.tables.find(sels.row, sels.col);// 获取table
                if (table) {
                    let range=table.dataRange();
                    this.$emit('getargData',(res)=>{
                        this.argData=res;
                    let arg = {};
                    obj.parm.forEach(item => {
                        if (_this.argData.hasOwnProperty(item.data)) {
                            arg[item.name] = _this.argData[item.data];
                            if (_this.argData.hasOwnProperty(item.data + '_e')) arg[item.name + '_e'] = _this.argData[item.data + '_e'];
                            if (_this.argData.hasOwnProperty(item.data + '_s')) arg[item.name + '_s'] = _this.argData[item.data + '_s'];
                        } else {
                                if (this.spreadStyle.hasOwnProperty(table.name()) && (this.spreadStyle[table.name()].hasOwnProperty(item.data))) {
                                    let ts=this.spreadStyle[table.name()];

                                    arg[item.name] =ts[item.data].toString();
                                } else
                                    arg[item.name] = sheet.getValue(sels.row, range.col + table.getColumnIndexInTable(item.data));
                            }
                    });

                    let n={
                        filename: title,
                        arg:arg,
                        code:obj.url,
                        fid:"",
                        editState:-1,
                        liancha:1,
                              };
                    this.$emit('newView',n);
                    });
                }

            } ,//end

        }
    }
</script>


<style  lang="scss"  >
    .spread-comp {
        margin-top: 0px;
        height: 100%;
        width: 100%;

        .spread_content {
            position: relative;
            font-weight: normal;
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
        }
    }

    .set_pop_content {
        position: absolute;
        margin: 0;
        padding: 0;
        left: calc(100% - 210px);
        /*width: 300px;*/
        color: #774917;
        background: #585c63;
        height:auto;
        max-height: 600px;
        opacity: 0.95;
        overflow: auto;

    }

</style>